import React from 'react';
import { IonIcon } from '@ionic/react';
import { closeOutline } from 'ionicons/icons';

type HeaderProps = {
	pageTitle: string,
  closeModal?: () => void
}

const SmallModalHeader = ({ closeModal, pageTitle }: HeaderProps ) => {
  return (
    <section className="infoScreenModal__header">
      <h2>{pageTitle}</h2>
      <article>
        <button 
          className="circle_small button_shadow"
          onClick={closeModal}>
          <IonIcon icon={closeOutline} size="large"/>
        </button>
      </article>
    </section>
  )
}

export default SmallModalHeader